/* eslint-disable */
import api from '@/services/api';

export default {
  async fetchFretes({ commit, dispatch }, payload) {
    const keys = Object.keys(payload);
    const params = new URLSearchParams();

    for (const key of keys) {
      if (payload[key]) {
        params.append(key, payload[key]);
      }
    }

    dispatch('toggleLoading', true, { root: true });

    const response = await api.get('/esl/fretes', { params });
    commit('SET_FRETES', response.data.data);
    if (response.data.misc) {
      commit('SET_DASHBOARD_FRETES', response.data.misc);
    }
    commit('paginacao/SET_PAGINADOR', response.data, { root: true });
    dispatch('toggleLoading', false, { root: true });
  },
  limparFretes({ commit }) {
    commit('SET_FRETES', {});
    commit('RESET_DASHBOARD_FRETES');
  },
  async prepararExcel() {
    const { data } = await api.get('/esl/excel-fretes');
    return data;
  },
  async prepararExcelAnalise() {
    const { data } = await api.get('/esl/excel-analise');
    return data;
  },
  async filtrar({ commit }, payload) {
    return commit('SET_FILTROS', payload);
  },
  async getColunasAnalise({ commit }) {
    function formatarData(data) {
      const meses = [
          "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
          "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
      ];
      const mes = meses[data.getMonth()];
      const ano = data.getFullYear().toString().slice(-2);
      return `${mes}/${ano}`;
    }

    const ultimosTresMeses = [];
    const dataAtual = new Date();

    for (let i = 0; i < 3; i++) {
        const data = new Date();
        data.setMonth(dataAtual.getMonth() - i);
        ultimosTresMeses.push(formatarData(data));
    }

    const colunasAnalise = [
      {
        value: 'pagador',
        i18n: '',
        text: 'Pagador',
        sortable: true,
        filterable: true,
        filterComponent: 'TextFilter',
        width: 400,
      },
      {
        value: 'freteTotal',
        i18n: '',
        text: 'Total',
        sortable: true,
        filterable: true,
        filterComponent: 'TextFilter',
      },
      {
        value: 'freteUltimoMes',
        i18n: '',
        text: ultimosTresMeses[0],
        sortable: true,
        filterable: true,
        filterComponent: 'TextFilter',
      },
      {
        value: 'fretePenultimoMes',
        i18n: '',
        text: ultimosTresMeses[1],
        sortable: true,
        filterable: true,
        filterComponent: 'DateFilter',
      },
      {
        value: 'freteAntepenultimoMes',
        i18n: '',
        text: ultimosTresMeses[2],
        sortable: true,
        filterable: true,
        filterComponent: 'TextFilter',
      },
    ];
    commit('SET_ANALISE_HEADERS', colunasAnalise);
  },
};
